// btw-front/src/components/ui/Container.jsx
import React from "react";

export default function Container({ className = "", children }) {
  return <div className={`btw-container ${className}`}>{children}</div>;
}
